import { ConnectionType } from '../enum';
import { DeviceNetwork } from '../model';
import { NetworkExtras } from '../type';

export class DeviceNetworkMapper {
  public static map(data: any): DeviceNetwork {
    if (!data) {
      return new DeviceNetwork(ConnectionType.UNKNOWN, '');
    }

    const extras: NetworkExtras = {};

    if (data.currentConnection === ConnectionType.CELLULAR) {
      extras.cellularType = data.cellular.connectionType ?? '';
      extras.signalStrength = data.cellular.signalStrength;
    } else if (data.currentConnection === ConnectionType.WIFI) {
      extras.macAddress = data.wifi.macAddress ?? '';
      extras.wifiSsid = data.wifi.ssid ?? '';
    }

    return new DeviceNetwork(
      data.currentConnection,
      data[data.currentConnection]?.ipAddress ?? '',
      extras
    );
  }
}
